import React from 'react'
import { useTranslation } from 'react-i18next';
import useTitle from 'hooks/useTitle'
import InvoiceWizard from './invoice-wizard';
import useStores from 'hooks/useStores';
import uiStore from 'stores/uiStore';

const InvoiceRegister = () => {
    const { t } = useTranslation();
    useTitle('registering_invoice')
    const { invoicesStore } = useStores()

    async function sendData() {
        await invoicesStore.postNewCompleteDocument()
        uiStore.notifySuccess(t('invoice_registered_successfully'))
        window.location.reload()
    }

    return (
        <InvoiceWizard
            title={t('registering_invoice')}
            onSendData={sendData} />
    )
}

export default InvoiceRegister